import { render } from "./SearchResultPage.vue?vue&type=template&id=1f2938ba"
import script from "./SearchResultPage.vue?vue&type=script&lang=js"
export * from "./SearchResultPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__